import script from "./iconKey.vue?vue&type=script&setup=true&lang=ts"
export * from "./iconKey.vue?vue&type=script&setup=true&lang=ts"

import "./iconKey.vue?vue&type=style&index=0&id=123b99a4&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-123b99a4"]])

export default __exports__